import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core'

import { CommonModule } from '@angular/common'
import { FormControl } from '@angular/forms'
import { SharedModule } from '@app/shared/shared.module'

@Component({
  selector: 'scope-ui-toggle',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './scope-ui-toggle.component.html',
  styleUrls: ['./scope-ui-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScopeUiToggleComponent {
  @Input() title: string
  @Input() description: string
  @Input() control: FormControl = new FormControl()

  @Input() set initialValue(value: boolean) {
    this.value = value
    if (this.control.value !== value) this.control.setValue(value)
    this.cdr.detectChanges()
  }

  @Input() set isDisabled(value: boolean) {
    value ? this.control.disable() : this.control.enable()
  }

  @Output() onToggleChange = new EventEmitter<boolean>()

  value: boolean

  constructor(private cdr: ChangeDetectorRef) {}

  onToggle(value: boolean) {
    this.onToggleChange.emit(value)
  }
}
